export const isTemporaryConversation = (conversationId?: string): boolean =>
  conversationId?.startsWith('temp-') ?? false;
